<template>
  <div>
    <!-- todo 需要数据验证 -->
    <van-nav-bar
      class="backBox"
      title="意见反馈"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="message_box">
        <div class="create-time">
          <div class="msgBeforeTit">上报时间：</div>
          <div class="msgAfterText">{{ createTime }}</div>
        </div>

        <div class="content-wrap">
          <div class="content-title msgBeforeTit">意见反馈：</div>
          <span class="msgAfterText">{{ content }}</span>
        </div>

        <div v-if="images.length" class="image-list-parent">
          <div v-for="item in images" :key="item.id" class="image-item">
            <img class="full-image" :src="item" />
          </div>
        </div>
        <van-divider />

        <div v-if="reply_time">
          <!-- <view class="line"></view> -->
          <div class="reply-wrap msgBeforeTit">管理员回复</div>
          <div>
           <span class="msgBeforeTit">时间：</span> <span class="msgAfterText">{{ reply_time }}</span>
          </div>
          <div class="content-bottom-wrap">
            <span class="msgAfterText">{{ comment }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'

export default {
  data () {
    return {
      createTime: '',
      content: '',
      detailObj: {},

      id: null,

      images: [],
      reply_time: '',
      result: '',
      comment: '',
      roomName: '',
      haddleOption: [
        { value: 1, name: '未解决', checked: 'true' },
        { value: 2, name: '已解决' },
        { value: 3, name: '不解决' }
      ]

    }
  },
  mounted () {
    this.detailObj = this.$route.query
    this.queryList()
  },
  computed: {

  },
  methods: {
    queryList () {
      const para = {
        id: this.detailObj.id
      }
      api
        .axiosRequest(api.urlList.queryComplainttMsg, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            const createTime = utils.formatDate(res.create_time)
            const replyTime = utils.formatDate(res.reply_time)

            const images = []

            if (Array.isArray(res.pic_url_list)) {
              res.pic_url_list.forEach(function (item, i) {
                images.push(api.getPicUrl(item))
              })
            }

            // 赋值
            this.createTime = utils.formatZHYMDHM(createTime)
            // Toast(this.createTime)
            this.content = res.content
            this.reply_time = utils.formatZHYMDHM(replyTime)
            this.result = res.result ? res.request : ''
            this.comment = res.comment ? res.comment : '暂无回复'
            // this.roomName = res.roomName
            this.images = images
            if (replyTime) {
              this.readMag()
            }
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    readMag () {
      const para = {
        announcement_id: this.detailObj.id
      }
      api
        .axiosRequest(api.urlList.readMsg, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {

          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  .message_box {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0.625rem 0.9375rem;
    background-color: #fff;
    color: #666;

    .create-time {
      display: flex;
      align-items: center;
      font-size: 1rem;
      color: #666;
    }
    .content-wrap {
      margin-top: 0.625rem;
      display: flex;
    }

    .content-title {
      white-space: nowrap;
      font-size: 1rem;
      color: #666;
    }

    .content-txt {
      font-weight: 300;
      font-size: 1rem;
    }
    .image-list-parent {
      margin-top: 0.9375rem;
      // margin-left: 0.875rem;
      // margin-right: 0.875rem;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .image-item {
      position: relative;
      width: 6.875rem;
      height: 6.875rem;
      margin-right: 0.3125rem;
      margin-bottom: 0.3125rem;
      background-color: #d8d8d8;
      .full-image {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
